import { Injectable } from '@angular/core';


@Injectable({
    providedIn: "root",
})

export class TableParameterService {
    public changeTableHeigh(currentHeight: number): number {
        if(currentHeight === 1000) {
            return 500;
        } else if(currentHeight === 700) {
            return 1000;
        } else if(currentHeight === 500) {
            return 700;
        } else {
            return 700;
        }
    }
}